module.exports = __webpack_public_path__ + "static/media/img1-3.cabe16ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/nutricheck_foliar/K/img1-3.png
// module id = 1582
// module chunks = 3